import { createRouter, createWebHistory } from 'vue-router';
import WelcomePage from '@/components/WelcomePage.vue';
import RulesPage from '@/components/RulesPage.vue';
import AdHocGamePage from '@/components/AdHocGamePage.vue';
import LeaguePage from '@/components/LeaguePage.vue';
import LoginPage from '@/components/LoginPage.vue';
import RegisterPage from '@/components/RegisterPage.vue';

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: WelcomePage
  },
  {
    path: '/rules',
    name: 'Rules',
    component: RulesPage
  },
  {
    path: '/adhoc-game',
    name: 'AdHocGame',
    component: AdHocGamePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/league',
    name: 'League',
    component: LeaguePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  }
];

// Router erstellen
const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation Guard für Authentifizierung
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && localStorage.getItem('isAuthenticated') !== 'true') {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;
